import { render, staticRenderFns } from "./CurrentEvents.vue?vue&type=template&id=5ba274f6&scoped=true&"
import script from "./CurrentEvents.vue?vue&type=script&lang=js&"
export * from "./CurrentEvents.vue?vue&type=script&lang=js&"
import style0 from "./CurrentEvents.vue?vue&type=style&index=0&id=5ba274f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba274f6",
  null
  
)

export default component.exports